import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'fcp-list-publishing',
  templateUrl: './list-publishing.component.html',
  styleUrls: ['./list-publishing.component.scss']
})
export class ListPublishingComponent implements OnInit {
  @Input() public publishing: any;
  @Input() public publishingAbout: any;
  @Input() public page: number;
  @Input() public totalItems: number;
  @Input() private buttonSetting: any;
  @Output() public clickedPage: EventEmitter<any> = new EventEmitter();
  @Output() public clickedModal: EventEmitter<any> = new EventEmitter();

  public button;
  public hasPagination: boolean;

  public config = {
    id: 'custom',
    itemsPerPage: 12,
    currentPage: 1,
    totalItems: 1
  };

  constructor() {}

  ngOnInit() {
    this.config.currentPage = this.page;
    if (this.totalItems > this.config.itemsPerPage) {
      this.config.totalItems = this.totalItems;
      this.hasPagination = true;
    }
    this.button = [
      {
        title: this.buttonSetting?.label,
        url: '',
        color: this.buttonSetting?.style,
        modal: null,
        page: ''
      }
    ];
  }

  public changePage(page) {
    this.clickedPage.emit(page);
    this.config.currentPage = page;
  }

  public openModal(modal: string) {
    if (modal) {
      this.clickedModal.emit(modal);
    }
  }

  public getBackground(attr) {
    return {
      background: `linear-gradient(90deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%), url(${attr})`
    };
  }
}
